module.exports = __webpack_public_path__ + "static/img/Royal-Standard.2a22f63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Royal-Standard.jpg
// module id = Cvae
// module chunks = 0